// extracted by mini-css-extract-plugin
export default {"integrationsArrow":"integrationsArrow--FUt19","integrationsIcons":"integrationsIcons--VYHam","integrationsIconsGap":"integrationsIconsGap--X7iJT","betaBadge":"betaBadge--PY41H"};